<script setup lang="ts">
import {
  OrButtonV3 as OrButton,
} from '@onereach/ui-components';

import LoginContainer from '../layouts/LoginContainer.vue';

const reload = () => {
  window.parent.postMessage({ type: 'AUTH_SESSION_EXPIRATION_RELOAD' }, '*');
};
</script>

<template>
  <LoginContainer
    ref="cookieExpireModal"
    class="relogin-modal"
    :background="true"
  >
    <div
      class="reload-form px-md sm:px-0 layout-column gap-sm+ items-center "
    >
      <div class="typography-headline-2 text-center max-w-[290px]">
        {{ $t('session_expire.You signed in with another account') }}
      </div>
      <div class="button-wrapper">
        <OrButton
          class="reload h-2xl"
          color="primary"
          @click="reload"
        >
          {{ $t('session_expire.Reload') }}
        </OrButton>
      </div>
    </div>
  </LoginContainer>
</template>
